import {
  traineeList,
  traineeLetter,
  traineeDocuments,
  traineeCourses,
  traineeAssessment,
  traineeCertificates
} from "constants/trainee";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

//get visitor list
export const getTraineeList = async (
  dispatch,
  pageNum,
  filterParams,
  searchString,
) => {
  try {
    const res = await api.trainee_list(pageNum, filterParams, searchString);
    dispatch({ type: traineeList, payload: res?.data });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: traineeList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

export const downloadTraineeQRCode = async (traineeId) => {
  try {
    const res = await api.download_qr_code(traineeId);
    return res;
  } catch (error) {
    if (error?.response && error?.response?.data instanceof Blob) {
      const text = await error?.response?.data.text();
      const json = JSON.parse(text);
      return json;
    }

    return (
      error.response?.data || {
        code: 500,
        status: "FAILED",
        message: "Failed to download QR code. Please try again.",
      }
    );
  }
};

// add trainee
export const addTrainee = async (bodyData) => {
  try {
    const res = await api.add_trainee(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

//get trainee detail by id
export const getTraineeDetailByID = async (id) => {
  try {
    const res = await api.get_trainee_details_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//edit trainee
export const editTrainee = async (id, bodyData) => {
  try {
    const res = await api.edit_trainee(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//trainee letters list
export const getTraineeLetter = async (
  dispatch,
  pageNum,
  filterParams,
  userID,
) => {
  try {
    const res = await api.get_trainee_letter(pageNum, filterParams, userID);

    dispatch({
      type: traineeLetter,
      payload: res?.data,
    });
  } catch (error) {
    authorizedUser(error?.response?.data);

    dispatch({
      type: traineeLetter,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

//get trainee detail by id
export const getTraineeDocumentsByID = async (dispatch, id) => {
  try {
    const res = await api.get_trainee_documents(id);

    dispatch({
      type: traineeDocuments,
      payload: res?.data,
    });
  } catch (error) {
    authorizedUser(error?.response?.data);

    dispatch({
      type: traineeDocuments,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

export const updateTraineeDocuments = async (traineeId, bodyData) => {
  try {
    const res = await api.update_trainee_documents(traineeId, bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const deleteTraineeDocument = async (id, bodyData) => {
  try {
    const res = await api.delete_trainee_document(id, bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const uploadTraineeDocuments = async (id, formData) => {
  try {
    const res = await api.upload_trainee_documents(id, formData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const getTraineeCourses = async (
  dispatch,
  id,
  pageNum,
  filterParams,
) => {
  try {
    const res = await api.get_trainee_courses(id, pageNum, filterParams);
    dispatch({
      type: traineeCourses,
      payload: res?.data,
    });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: traineeCourses,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};
// trainee assessment
export const getTraineeAssessment = async (
  dispatch,
  id,
  pageNum,
  filterParams,) => {
  try {
    const res = await api.get_trainee_assesment_list(id, pageNum, filterParams);
   dispatch({
      type: traineeAssessment,
      payload: res?.data,
    });
  } catch (error) {
    authorizedUser(error?.response?.data);

    dispatch({
      type: traineeAssessment,
      payload: error?.response?.data ?? {
        message: error?.message,
      },
    });
  }
};

// trainee assessment artifacts
export const getTraineeAssessmentArtifactFiles = async (
  traineeId,
  assessmentId,
) => {
  try {
     const res = await api.get_trainee_assessment_artifact_files(
      traineeId,
      assessmentId,
    );
    return res?.data;
  } catch (error) {
    
  authorizedUser(error?.response?.data);

 return error?.response?.data || error;
  }
};
// trainee certificate 
export const getTraineeCertificates = async (dispatch, id) => {
  try {
    const res = await api.get_trainee_certificates(id);

    dispatch({ type: traineeCertificates, payload: res.data });
  } catch (error) {
    authorizedUser(error?.response?.data);

    dispatch({
      type: traineeCertificates,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};